// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"Ws-z","mainContent":"Xs-z","activeSidebar":"Ys-z"};